import { SaleFilter } from '@/types/filters/filters.types';
import { atom } from 'recoil';

export const saleFilterState = atom<SaleFilter>({
  key: 'sale',
  default: {},
});
